
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40 20.12C39.998 9.416 31.668.586 21.044.028 10.42-.531 1.221 7.378.111 18.023-1 28.67 6.368 38.326 16.876 40V25.936h-5.078V20.12h5.078v-4.434c0-5.043 2.986-7.829 7.553-7.829 1.5.021 2.997.153 4.477.393v4.952h-2.521a2.895 2.895 0 00-3.258 3.145v3.773h5.546l-.886 5.816h-4.661V40C32.845 38.452 40.002 30.02 40 20.12z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    